var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"app-footer"},[_c('span',[_c('a',{attrs:{"href":"https://coreui.io"}},[_vm._v("CoreUI")]),_vm._v(" © 2018 creativeLabs.")]),_vm._v(" "),_c('span',{staticClass:"ml-auto"},[_vm._v("Powered by "),_c('a',{attrs:{"href":"https://coreui.io"}},[_vm._v("CoreUI")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ffa178b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 1011
// module chunks = 3